export default __webpack_public_path__ + "static/media/bottle-blue.245b3bf3.png";